import whatYouNeedApi from "../../api/whatYouNeedApi";
import {
  whatYouNeed,
  redeemPoints,
  setMissionsLoading,
  setRewardMissions,
  setRewardMissionsError,
} from "./DialogPolicyPointReducer";
import _ from "lodash";

export function getWhatYouNeed(data) {
  return (dispatch) => {
    return whatYouNeedApi.whatYouNeed(data).then(
      (res) => {
        dispatch(whatYouNeed(res));
      },
      (error) => {
        throw error;
      }
    );
  };
}

export function getRedeemPoints(data) {
  return (dispatch) => {
    dispatch(redeemPoints(null));
    return whatYouNeedApi.redeemPoints(data).then(
      (res) => {
        dispatch(redeemPoints(res));
      },
      (error) => {
        dispatch(redeemPoints(error));
        //throw error;
      }
    );
  };
}

export function resetRedeemPoints() {
  return (dispatch) => {
    dispatch(redeemPoints(null));
  };
}

export function getRewardMissions(opts = {}) {
  const force = !!(opts && opts.force);
  return (dispatch, getState) => {
    const { missionsLoading, missionsLoaded } = getState().dialogPolicyPointReducer;
    if (!force && (missionsLoading || missionsLoaded)) {
      return Promise.resolve();
    }
    dispatch(setMissionsLoading(true));
    return whatYouNeedApi.rewardMissions().then(
      (res) => {
        dispatch(setRewardMissions(res));
      },
      () => {
        dispatch(setRewardMissionsError());
      }
    );
  };
}